import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { message } from 'antd'
import { Icon } from '@ant-design/compatible'
import { UdTable, UdFilter, IUdFormItem } from '@ud/admin-framework'
import SelectedShow from '../SelectedShow'
import DepartmentTree from '../DepartmentTree'
import '../modalPublicStyle.less'

const columns = [
  { title: '部门编码', dataIndex: 'uid' },
  { title: '部门名称', dataIndex: 'name' },
]

const conditions: IUdFormItem[] = [
  {
    name: 'name', label: '部门名称', col: { span: 12 }
  },
]

const SelectDepartment: React.FC<ISelectDepartmentProps> = (props) => {
  const [querying, setQuerYing] = useState<boolean>(false)
  const [dataSource, setDataSource] = useState<any[]>([])
  const [oldDataSource, setOldDataSource] = useState<any[]>([])

  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([])
  const [selectedRows, setSelectedRows] = useState<any[]>([])
  const [selectAllData, setSelectAllData] = useState<any[]>([])

  const rowSelection: any = {
    onChange: (keysArr: any, rowArr: any) => {
      setSelectedRowKeys(keysArr)
      let arr: any = selectAllData
      arr.push(...rowArr)
      setSelectAllData(_.uniqBy(arr, 'uid'))
    },
    selectedRowKeys,
    type: props.receiveData.rowSelectionType ? props.receiveData.rowSelectionType : 'checkbox'
  };

  const handleSearch = (v: any) => {
    if (v.name && v.name !== '') {
      if (dataSource && dataSource.length > 0) {
        const newDataSource = dataSource.filter((n) => n.name.indexOf(v.name) > -1)
        console.log(newDataSource)
        setDataSource(newDataSource)
      } else {
        message.warning('请选择树节点后在搜搜')
      }
    } else {
      setDataSource(oldDataSource)
    }
  }

  const filterReset = () => {
    // if (dataSource && dataSource.length > 0) {

    // } else {

    // }
    setDataSource(oldDataSource)
  }

  const deleteSelect = (v: any) => {
    const newSelectedRowKeys = _.remove(selectedRowKeys, (n) => n !== v.uid)
    const newSelectedRows = _.remove(selectedRows, (n) => n.uid !== v.uid)

    rowSelection.onChange(newSelectedRowKeys, newSelectedRows)
  }

  const emptySelect = () => {
    rowSelection.onChange([], [])
  }

  const getableData = (node: any) => {
    const arr: any = []
    if (node && node.children && node.children.length > 0) {
      setQuerYing(true)
      node.children.forEach((n: any) => {
        arr.push({
          uid: n.uid,
          name: n.name
        })
      })
      setDataSource(arr)
      setOldDataSource(arr)
      setQuerYing(false)
    } else {
      setDataSource([])
      setOldDataSource([])
    }
  }

  useEffect(() => {
    props.getHandler(() => {
      return {
        selectedRowKeys,
        selectedRows: selectAllData,
        contentType: props.receiveData.contentType,
        otherParams: props.receiveData.otherParams || null
      }
    })
  })

  useEffect(() => {
    let arr: any = []
    selectedRowKeys.forEach((v) => {
      const item = _.find(selectAllData, n => n.uid === v)
      if (item) {
        arr.push(item)
      }
    })
    setSelectAllData(arr)
  }, [selectedRowKeys])

  useEffect(() => {
    const defaultData = props.receiveData.data
    if (defaultData && defaultData.selectedRowKeys && defaultData.selectedRows) {
      setSelectedRowKeys(defaultData.selectedRowKeys)
      setSelectAllData(defaultData.selectedRows)
    }
  }, [props.receiveData])

  return (
    <div className="select-modal-style">
      <div className="left">
        <div className="tree-box">
          <DepartmentTree selectTreeNode={(id: any, node: any) => { getableData(node) }} />
        </div>
      </div>
      <div className="content">
        <div className="search-box">
          <UdFilter
            loading={querying} items={conditions}
            onSearch={handleSearch} onReset={filterReset}
          ></UdFilter>
        </div>
        <div className="table-box">
          <UdTable
            rowKey={"uid"}
            loading={querying}
            columns={columns}
            dataSource={dataSource}
            useColumnCustomize={false}
            useExport={false}
            // onChange={handleTableChange}
            rowSelection={rowSelection}
            pagination={false}
          />
        </div>
      </div>
      <div className="right">
        <div className="title">
          已选部门
        </div>
        <div className="select-box">
          <SelectedShow deleteSelect={(v: any) => deleteSelect(v)} selectedRows={selectAllData} />
        </div>
        <div className="empty-box">
          <span onClick={emptySelect}>清空
            <Icon type="delete" />
          </span>
        </div>
      </div>
    </div>
  )
}

interface ISelectDepartmentProps {
  getHandler?: any
  receiveData?: any
}


export default SelectDepartment